import { Injectable, TemplateRef } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
     providedIn: 'root'
})
export class SessionTimerService {

     showTimeOutWarning: boolean = false;
     timeout: number = -1;
     timerObj: any = null;
     jwt: any = null;
     showSessionTimer: boolean = false;
     intervalObj: any = null;
     secondsRemaining: number = 60;
     timerActive:boolean = false;
     modelRef?:TemplateRef<any> 
     constructor(private authenticationService: AuthenticationService, public modalService: NgbModal) { }

     setModelRef(mr:TemplateRef<any>){
          if(this.modelRef === undefined){
               this.modelRef = mr;
          }
     }

     clear(){
          clearInterval(this.timerObj);
          this.timerObj = null;
          clearInterval(this.intervalObj);
          this.intervalObj = null;
          this.timerActive = false;
     }

     setTimeout() {
          const user = this.authenticationService.getUser();
          if (user) {
               const token = user.token;
               if (token) {
                    this.jwt = this.parseJwt(token);
               }
               if (this.jwt) {
                    this.timerObj = null;
                    this.timeout =
                         Math.abs(
                         new Date(+this.jwt.exp * 1000).getTime() -
                         new Date(+this.jwt.iat * 1000).getTime()
                    ) - 60000;
                    this.timerObj = setInterval(() => {
                         this.showSessionTimer = true;
                         this.modalService.open(this.modelRef, {
                              backdrop: 'static', // Prevent closing on background click
                              keyboard: false,     // Prevent closing on ESC key press (optional)
                              ariaLabelledBy: 'areYouStillThereModalTitle' 
                            });
                         this.timerActive = true;
                         this.startCount();
                    }, this.timeout);
               }
          }
     }

     startCount() {
          clearInterval(this.timerObj);
          this.secondsRemaining = 60;
          this.getSecondsRemaining();
     }

     get showTimeRemaining(){
          return this.secondsRemaining;
     }

     extendSession() {
           if (this.intervalObj !== null) {
               this.secondsRemaining = 60;
               this.clear();
               this.intervalObj = null;
           }

           this.authenticationService.refreshToken().subscribe((resp:any) => {
               if(resp){
                    this.showSessionTimer = false;
                    this.modalService.dismissAll(this.modelRef);
                    this.clear();
                    this.setTimeout();
               }else{
                    this.clear();
                    this.authenticationService.logout();
               } 
           });
     }

     public getSecondsRemaining() {
          this.intervalObj = setInterval(() => {
               this.secondsRemaining = this.secondsRemaining - 1;
               //I have this here to make sure I am not running the timer when we think it should be cleared.
               if (this.secondsRemaining <= 0) {
                    this.secondsRemaining = 0;
                    clearInterval(this.intervalObj);
                    this.authenticationService.logout();
               }
          }, 1000);
     }


     private parseJwt(token: any): any {
          if (!token) {
               return;
          }
          const base64Url = token.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(
               atob(base64)
                    .split('')
                    .map(function (c) {
                         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join('')
          );
          return JSON.parse(jsonPayload);
     }



}
